import React from 'react';
import Footer from '../Footer';
import CheckboxOption from '../Elements/CheckboxOption';
import CalendarSlide from './CalendarSlide';
import TextElement from '../Elements/TextElement';
import MultipleOptionSlide from '../Elements/MultipleOptionElement';
import InfoElement from '../Elements/InfoElement';
import WhatsappToggle from '../WhatsappToggle';
import styles from '../../../../../../styles/leadform.module.css';
import { MAKE_UP_ARTIST_MODEL } from '../../../../../../constants/constants';
import moment from 'moment';
import Icon from '../../../../../../layouts/common/icons/Icon';
import SelectDateYearSlide from './SelectDateYearSlide';

export default function Slide(props) {
    const showWhatsappToggle = (elements) => {
        if (
            elements &&
            elements.length === 2 &&
            elements.every(
                (item) =>
                    item.textPlaceholder === 'Enter Name' || item.textPlaceholder === 'Enter Phone'
            )
        ) {
            return <WhatsappToggle getWhatsappToggleStatus={props.getWhatsappToggleStatus} />;
        }
    };

    const getFinalButtonText = () => {
        let { leadFormMode, finalBtnText } = props;
        if (leadFormMode === MAKE_UP_ARTIST_MODEL) {
            return `Search Artists`;
        }
        return finalBtnText ? finalBtnText : `Find Venues`;
    };

    const getCurrentElementType = () => {
        if (props && props.elements && props.elements.length > 0) {
            const currentElement = props.elements[0];

            return currentElement.elementType;
        }
        return null;
    };

    return (
        <div className={styles['leadform-slide-shell']}>
            <div className={`vm-leadform-slide ${styles['leadform-slide-scroll']}`}>
                <div>
                    {getCurrentElementType() == 'text' && !_.isEmpty(props.heavyDate) ? (
                        <div className={styles['contact-info-header']}>
                            <Icon
                                iconName={'lead_form_availaibility'}
                                className={styles['contact-info-header-icon']}
                            />
                            <div className={styles['contact-info-header-text-container']}>
                                <span className={styles['contact-info-header-main-heading']}>
                                    {props.heavyDate.venue_availability_percentage}% of Venues on{' '}
                                    <span className={styles['contact-info-header-date']}>
                                        {moment(props.event_date).format('DD-MM-YYYY')}
                                    </span>{' '}
                                    are booked
                                </span>
                                <span className={styles['contact-info-header-subheading']}>
                                    Get Available Venues Immediately!
                                </span>
                            </div>
                        </div>
                    ) : (
                        <h3 id="leadFormSlideQuestion" dangerouslySetInnerHTML={{__html: props.questionText}}></h3>
                    )}
                    <div>
                        {props.elements &&
                            props.elements.length > 0 &&
                            props.elements.map((element) => {
                                if (element.elementType === 'radio') {
                                    return (
                                        <CheckboxOption
                                            element={element}
                                            slideId={props.slideId}
                                            elementId={element._id}
                                            handleOptionSelect={props.handleOptionSelect}
                                            key={element._id}
                                            handleOptionSearch={props.handleOptionSearch}
                                            qtext={props.qtext}
                                            isShowSearch={element.isSearchAllowed}
                                        />
                                    );
                                } else if (element.elementType === 'date-year') {
                                    return (
                                        <SelectDateYearSlide
                                            selectedMonth={props.selectedMonth}
                                            selectedYear={props.selectedYear}
                                            handleMonthSelect={props.handleMonthSelect}
                                            handleYearSelect={props.handleYearSelect}
                                        />
                                    );
                                } else if (element.elementType === 'date') {
                                    return (
                                        <CalendarSlide
                                            heavyDate={props.heavyDate}
                                            key={element._id}
                                            slideId={props.slideId}
                                            elementId={element._id}
                                            initialDate={props.initialDate}
                                            selectedDate ={element.selectedValue}
                                            handleDateSelect={props.handleDateSelect}
                                        />
                                    );
                                } else if (element.elementType === 'text') {
                                    return (
                                        <>
                                            <TextElement
                                                key={element._id}
                                                elementId={element._id}
                                                slideId={props.slideId}
                                                element={element}
                                                handleTextOptionFocus={props.handleTextOptionFocus}
                                                handleTextOptionSelect={
                                                    props.handleTextOptionSelect
                                                }
                                                countryCodeDict={props.countryCodeDict}
                                                nation={props.nation}
                                            />
                                        </>
                                    );
                                } else if (element.elementType === 'checkbox') {
                                    return (
                                        <MultipleOptionSlide
                                            key={element._id}
                                            slideId={props.slideId}
                                            elementId={element._id}
                                            element={element}
                                            handleMultiOptionSelect={props.handleMultiOptionSelect}
                                            icon={`vm_uncheckedtickbox_icon`}
                                            selectedIcon={`vm_orangetickbox_icon`}
                                            handleOptionSearch={props.handleOptionSearch}
                                            qtext={props.qtext}
                                            isShowSearch={element.isSearchAllowed}
                                        />
                                    );
                                }
                                else if (element.elementType === 'multikey-checkbox') {
                                    return (
                                        <MultipleOptionSlide
                                            key={element._id}
                                            slideId={props.slideId}
                                            elementId={element._id}
                                            element={element}
                                            handleMultiOptionSelect={props.handleMultiOptionSelect}
                                            icon={`vm_uncheckedtickbox_icon`}
                                            selectedIcon={`vm_orangetickbox_icon`}
                                            handleOptionSearch={props.handleOptionSearch}
                                            qtext={props.qtext}
                                            isShowSearch={element.isSearchAllowed}
                                        />
                                    );
                                } 
                                else if (element.elementType === 'info') {
                                    return (
                                        <InfoElement
                                            key={element._id}
                                            slideId={props.slideId}
                                            infoHtml={element.infoHtml}
                                        />
                                    );
                                }
                            })}
                    </div>

                    <div className="col-lg-12 col-md-12 col-sm-12" style={{ padding: '0 32px',marginTop:"20px" }}>
                        {showWhatsappToggle(props.elements)}
                    </div>
                </div>
            </div>
            <div className={styles['leadform-slide-footer']}>
                <Footer
                    embeddedLpStyle={props.embeddedLpStyle}
                    slideLength={props.slideLength}
                    isTriggerSlide={props.isTriggerSlide}
                    isLastBtn={props.isLastBtn}
                    showPrevBtn={props.isPrevBtnVisible}
                    showNextBtn={props.isNextBtnVisible}
                    isSkipButtonVisible={props.isSkipButtonVisible}
                    currentIndex={props.currentIndex}
                    handleNextClick={props.handleNextClick}
                    handleBackClick={props.handleBackClick}
                    handleSkipButtonClick={props.handleSkipButtonClick}
                    amplitudeEventName={props.amplitudeEventName}
                    isLoadingLeadForm={props.isLoadingLeadForm}
                    isPlanningEvent={props.isPlanningEvent}
                    finalBtnText={getFinalButtonText()}
                    prevBtnText={props.prevBtnText}
                    nextBtnText={props.nextBtnText}
                />
            </div>
        </div>
    );
}
